import React, { useEffect, useRef } from "react";
import "./GestionDepotOffre.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import GestionDepotOffreCard from "./GestionDepotOffreCard/GestionDepotOffreCard";
import { useState } from "react";
import { updateOffers } from "Redux/Actions/offersActions";
import { updatePagination } from "Redux/Actions/paginationActions";
import Offre from "../Offre/Offre";
import {
  filterByTransmitter,
  formatDate,
  stripHtml,
  truncate,
} from "Services/functions";
import Management from "Components/Management/Management";
import Loader from "Components/Loader/loader";
import { useFetchGetPagination } from "Services/api";
import TempPagination from "Components/Pagination/TempPagination";
import { ME, offerMgmtButtons } from "Components/Management/ManagementButtons";

const GestionDepotOffre = (props) => {
  // *****************************************************************
  // ****************** UseStates / UseRef *********************
  // *****************************************************************
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [url, setUrl] = useState(null);
  const depotOffreRef = useRef(null);
  const [states, setStates] = useState(null);
  const [lastOffre, setLastOffre] = useState(null);
  const [btnList, setBtnList] = useState(
    offerMgmtButtons.map((x) => {
      return { ...x };
    })
  );
  //? On ne fait pas de requête si aucun état n'est sélectionné
  //? Des états par défaut sont appliqués dans un useEffect
  //! Permet d'éviter de faire deux requêtes au chargement de la page
  useFetchGetPagination(url, props.auth.token, props.handleUpdateOffers);

  // *****************************************************************
  // ****************** UseEffect *********************
  // *****************************************************************
  useEffect(() => {
    props.handleUpdateOffers({
      currentTransmitter: [ME],
    });
    return () => {
      props.handleUpdateOffers({
        dataFromPagination: null,
      });
    };
  }, []);

  useEffect(() => {
    if (states && states?.length > 0) {
      if (depotOffreRef.current !== null) {
        window.scroll({
          top: depotOffreRef.current.offsetTop,
          behavior: "smooth",
        });
      }
      let newUrl = new URL(`${process.env.REACT_APP_BASE_URL_API}/offers`);
      newUrl.searchParams.set(
        "university[]",
        props.auth.universityConnected.id
      );
      newUrl.searchParams.set("order[modifiedAt]", "desc");
      newUrl.searchParams.set("itemsPerPage", 20);
      states.forEach((state) => {
        newUrl.searchParams.append("state[]", state?.id);
      });
      newUrl.searchParams.append(
        "createdByUser[]",
        props.auth.userConnected.id
      );

      setUrl(newUrl);
    }
  }, [states]);

  useEffect(() => {
    /// Récupérer les states, et les filtrer par ordre alphabétique
    if (props.offers.statusData && props.offers.statusData.length > 0) {
      setStates([]);
      let tempArray = props.offers.statusData.map((state) => {
        return { ...state };
      });
      tempArray = tempArray.sort((a, b) => a.name.localeCompare(b.name));
      tempArray.forEach((state) => {
        if (state.name.lastIndexOf("é") === state.name.length - 1) {
          state.name = state.name + "e";
        }
      });

      setStates(tempArray);
    }
  }, [props.offers.statusData]);

  // Hook qui se déclenche quand la liste des offres change
  useEffect(() => {
    // Charge la dernière offre en fonction de l'emetteur choisi
    url?.href?.includes("page=1") &&
      setLastOffre(props.offers.dataFromPagination?.data[0]);
  }, [props.offers.dataFromPagination?.data]);

  return (
    <div className="gestion_depot_offre" ref={depotOffreRef}>
      <div className="gestion_depot_offre__title">
        <h1 className="h1_trait_dessus">
          {props.auth.isAdmin || props.auth.isValidator
            ? "Gérer les dépôts d'offres"
            : "Gérer mes dépôts d'offres"}
        </h1>
        <Management
          states={states}
          btnEntreprise={btnList[2]}
          btnDiffuseur={btnList[3]}
          actualPage={"offre"}
          currentTransmitter={
            btnList.filter((btn) => btn.isActive === true)[0].transmitter
          }
          updateFunction={props.handleUpdateOffers}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          url={url}
          setUrl={setUrl}
        ></Management>
      </div>

      <div className="gestion_depot_offre__container">
        <div className="gestion_depot_offre__container__left">
          {/* Gestion des boutons de gauche */}
          {(props.auth.isAdmin || props.auth.isValidator) &&
            btnList.map((btnStatus, index) => {
              return (
                <button
                  className={
                    btnStatus.isActive
                      ? "btn-bleu " + "item" + index
                      : "btn-blanc " + "item" + index
                  }
                  onClick={() => {
                    setUrl(
                      filterByTransmitter(
                        "offers",
                        url,
                        btnList[index].transmitter,
                        props.auth.userConnected.id
                      )
                    );
                    props.handleUpdateOffers({
                      currentTransmitter: btnList[index].transmitter,
                      dataFromPagination: null,
                    });
                    var i = 0;
                    setBtnList(
                      btnList.map((btn) => {
                        btn.isActive = i == index;
                        i++;
                        return btn;
                      })
                    );
                  }}
                  key={index}
                >
                  {btnList[index].text}
                </button>
              );
            })}

          <h3>Dernière offre créée</h3>

          {/* Affichage de la dernière offre */}
          {lastOffre !== null && lastOffre !== undefined && (
            <Offre
              categorie={0}
              url={lastOffre.imageUrl ? lastOffre.imageUrl : "img1"}
              offreDetails={lastOffre}
              date={formatDate(lastOffre.postedAt, ".")}
              accessibleForDisabled={lastOffre.accessibleForDisabled}
            />
          )}
        </div>

        <div className="gestion_depot_offre__container__right">
          {props.offers.dataFromPagination?.loaded > 0 ? (
            props.offers.dataFromPagination.data?.length > 0 ? (
              props.offers.dataFromPagination.data[0]?.state &&
              props.offers.dataFromPagination.data
                .filter(
                  (offre) =>
                    offre.state.statusLabel !== "Brouillon" ||
                    offre.createdByUser?.id == props.auth.userConnected.id
                )
                .sort((a, b) => new Date(b.modifiedAt) - new Date(a.modifiedAt))
                .map((offre) => (
                  <GestionDepotOffreCard
                    key={offre.id}
                    titre={offre.title}
                    entreprise={
                      offre.company?.name ? offre.company.name : "Non renseigné"
                    }
                    contrat={
                      offre.typeOfContract
                        ? offre.typeOfContract.label
                        : offre.offerCategory?.label
                    }
                    lieu={offre.city ? offre.city : "Non renseigné"}
                    statut={offre.state}
                    image={offre.company?.url}
                    niveau={
                      offre.levelOfEducations[0] != undefined &&
                      offre.levelOfEducations[0]
                        ? offre.levelOfEducations[0].label
                        : "Non renseigné"
                    }
                    description={truncate(stripHtml(offre?.description), 80)}
                    id={offre.id}
                    offre={offre}
                    feedback={offre.feedback?.feedback}
                  />
                ))
            ) : (
              <span>Aucune offre ne correspond à votre recherche</span>
            )
          ) : (
            <Loader />
          )}
        </div>
      </div>
      <TempPagination
        result={props.offers.dataFromPagination}
        refItemParent={depotOffreRef}
        rows={itemsPerPage}
      />
    </div>
  );
};

GestionDepotOffre.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
  handleUpdateOffers: PropTypes.func,
  offers: PropTypes.object,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  offers: state.offers,
  pagination: state.pagination,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateOffers: (value) => {
    dispatch(updateOffers(value));
  },
  handleUpdatePagination: (value) => {
    dispatch(updatePagination(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GestionDepotOffre);
